// extracted by mini-css-extract-plugin
export default {"searchResult":"Search_searchResult__NVU4X","loading":"Search_loading__LxYU-","searchIcon":"Search_searchIcon__kUf9C","searchContent":"Search_searchContent__YOJ6S"};